<template>
  <div>
  <v-row no-gutters class="justify-center align-center" style="margin-top: 150px;">
    <v-col cols="10" class="text-center main-text">
      <h1 class="font-weight-bold">{{ pageTitle }}</h1>
    </v-col>
  </v-row>

  <v-row class="justify-center align-center">
    <v-col cols="10">
      <div v-html="pageContent"></div> 
    </v-col>  
  </v-row>

  

  </div>

  
</template>



<script>
  export default {
    metaInfo() {
        return {
          titleTemplate: '%s | Our Project Summary',

          meta: [
          { vmid: 'meta_description', name: 'description', content: 'King Of Web Designs | Summary of our most recent projects'},
          { vmid: 'meta_keywords', name: 'keywords', content: 'Web Development Projects, King Of Web Design Projects, Laravel Examples, Laravel Projects, Vue Examples, Vue Projects, Vuetify Development, Websites Gloucestershire'},          
          { vmid: 'og:title', property: 'og:title', content: 'King Of Web Designs | Our Project Summary'},
          { vmid: 'og:description', property: 'og:description', content: 'King Of Web Designs | Summary of our most recent projects'},
          { vmid: 'og:url', property: 'og:url', content: this.site_url},
          { vmid: 'twitter:title', name: 'twitter:title', content: 'King Of Web Designs | Our Project Summary'},
          { vmid: 'twitter:description', name: 'twitter:description', content: 'King Of Web Designs | Summary of our most recent projects'},
          { vmid: 'google:name', itemprop: 'name', content: 'King Of Web Designs | Our Project Summary'},
          { vmid: 'google:description', itemprop: 'description', content: 'King Of Web Designs | Summary of our most recent projects'}, 

          ],



          link: [
            {vmid: 'canonical', rel: 'canonical', href: this.site_url}
          ],          
        }
    },
    data: () => ({
      
      pageTitle: '', 
      pageContent: '',    
      
      
    }),

    created () {
        this.initialize()
    },


    computed: { 

      site_url() {
        return 'https://www.kingofwebdesigns.co.uk/'+window.location.pathname;
      },     
      
    },
    watch: {
      
    },
    
    methods: {

      initialize () {         

          axios.get('/api/pages/'+this.$route.params.slug).then(response => {
            this.pageTitle = response.data.data[0].name;            
            this.pageContent = response.data.data[0].gutenberg_content;
          });

      },
      
    },
  };
</script>
<style scoped>

.card-actions {
  position: absolute;
  bottom: 0;
  width: 95%;
}

@media all and (max-width: 1330px) { 

  

}

@media all and (max-width: 1220px) { 

  

}

@media all and (max-width: 1100px) { 

  

}

@media all and (max-width: 1024px) {  
  

}

@media all and (max-width: 959px) { 

  

} 

@media all and (max-width: 839px) { 

  .main-text {
    margin-top: 100px;
    text-align: center !important;
    margin-left: 0px !important;
  }

  .card-actions {
    position: relative;  
    width: 100%;
  }
  
} 

 

@media all and (max-width: 480px) { 

}

@media only screen and (max-width: 1366px) and (orientation: landscape) {  
  
}

@media only screen and (max-width: 1024px) and (orientation: landscape) {  
  
}

@media only screen and (max-width: 839px) and (orientation: landscape) {

  
}

 
</style>